// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1Rh5B","legacyBtn":"MutateMid_legacyBtn__3zISz"};